/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use EditorModeEnum from application-types instead.
 */
export enum EditorModeEnum {
  Whitelabel = 'whitelabel',
  Channel = 'channel',
}
